import { createReducer, on } from '@ngrx/store';
import * as AssessmentActions from './assessment.actions';
import {
  Assessment,
  AssessmentCategory,
  UserAssessment,
} from './assessment.models';

export const assessmentFeatureKey = 'assessments';

export interface State {
  loadingAssessment: boolean;
  loadingAssessmentError: string;
  allAssessments: Assessment[];

  loadingAssessmentCategories: boolean;
  loadingAssessmentCategoriesError: string;
  assessmentCategories: AssessmentCategory[];

  loadingUserAssessments: boolean;
  loadingUserAssessmentsError: string;
  userAssessments: UserAssessment[];

  creatingUserAssessment: boolean;
  creatingUserAssessmentError: string;
  currentUserAssessment: UserAssessment;

  submittingAssessmentQuestion: boolean;
  submittingAssessmentQuestionError: string;
}

export const initialState: State = {
  loadingAssessment: false,
  loadingAssessmentError: null,
  allAssessments: [],

  loadingAssessmentCategories: false,
  loadingAssessmentCategoriesError: null,
  assessmentCategories: [],

  loadingUserAssessments: false,
  loadingUserAssessmentsError: null,
  userAssessments: [],

  creatingUserAssessment: false,
  creatingUserAssessmentError: null,
  currentUserAssessment: null,

  submittingAssessmentQuestion: false,
  submittingAssessmentQuestionError: null,
};

export const reducer = createReducer(
  initialState,

  on(AssessmentActions.loadAssessments, (state) => {
    return {
      ...state,
      loadingAssessmentError: null,
      loadingAssessment: true,
    };
  }),
  on(AssessmentActions.loadAssessmentsSuccess, (state, action) => {
    return {
      ...state,
      loadingAssessment: false,
      allAssessments: action.assessments,
    };
  }),
  on(AssessmentActions.loadAssessmentsFailure, (state, action) => {
    return {
      ...state,
      loadingAssessment: false,
      loadingAssessmentError: action.error,
    };
  }),
  on(AssessmentActions.loadUserAssessments, (state) => {
    return {
      ...state,
      loadingUserAssessments: false,
      loadingUserAssessmentsError: null,
    };
  }),
  on(AssessmentActions.loadUserAssessmentsSuccess, (state, action) => {
    return {
      ...state,
      loadingUserAssessments: false,
      userAssessments: action.assessments,
    };
  }),
  on(AssessmentActions.loadUserAssessmentsFailure, (state, action) => {
    return {
      ...state,
      loadingUserAssessments: false,
      loadingUserAssessmentsError: action.error,
    };
  }),
  on(AssessmentActions.createUserAssessment, (state) => {
    return {
      ...state,
      creatingUserAssessment: true,
      creatingUserAssessmentError: null,
    };
  }),
  on(AssessmentActions.createUserAssessmentSuccess, (state, action) => {
    return {
      ...state,
      creatingUserAssessment: false,
      currentUserAssessment: action.assessment,
    };
  }),
  on(AssessmentActions.createUserAssessmentFailure, (state, action) => {
    return {
      ...state,
      creatingUserAssessment: false,
      creatingUserAssessmentError: action.error,
    };
  }),
  on(AssessmentActions.submitUserAssessmentQuestion, (state) => {
    return {
      ...state,
      submittingAssessmentQuestion: true,
      submittingAssessmentQuestionError: null,
    };
  }),
  on(AssessmentActions.submitUserAssessmentQuestionSuccess, (state, action) => {
    return {
      ...state,
      submittingAssessmentQuestion: false,
      currentUserAssessment: action.assessment,
    };
  }),
  on(AssessmentActions.submitUserAssessmentQuestionFailure, (state, action) => {
    return {
      ...state,
      submittingAssessmentQuestion: false,
      submittingAssessmentQuestionError: action.error,
    };
  }),
  on(AssessmentActions.loadUserAssessment, (state) => {
    return {
      ...state,
      loadingAssessment: true,
      loadingAssessmentError: null
    }
  }),
  on(AssessmentActions.loadUserAssessmentSuccess, (state, action) => {
    return {
      ...state,
      loadingAssessment: false,
      currentUserAssessment: action.assessment
    }
  }),
  on(AssessmentActions.loadUserAssessmentFailure, (state, action) => {
    return {
      ...state,
      loadingAssessment: false,
      loadingAssessmentError: action.error
    }
  }),
  on(AssessmentActions.clearCurrentUserAssessment, (state) => {
    return {
      ...state,
      currentUserAssessment: null
    }
  }),
  on(AssessmentActions.clearAssessment, () => {
    return initialState;
  }),
);
